<app-captureswing *ngIf="showSwingCapture" (backToSessionClicked)="backToSession()" [session]="session"></app-captureswing>

<div class="layout-container" *ngIf="!showSwingCapture" [class.drawing-mode]="drawMode !== null" [class.compare-mode]="reviewTab === 'compare'">
  <!-- Left Menu Bar -->
  <div class="menu-bar">
    <div class="menu-icon"
         *ngIf="reviewTab === 'compare'"
         [class.active]="compareCamera === 'faceon'"
         (click)="setCompareCamera('faceon')"
         title="Face-On">
      <span class="menu-icon-text">FO</span>
    </div>
    <div class="menu-icon"
         *ngIf="reviewTab === 'compare'"
         [class.active]="compareCamera === 'dtl'"
         (click)="setCompareCamera('dtl')"
         title="Down the Line">
      <span class="menu-icon-text">DTL</span>
    </div>
    <div class="menu-separator" *ngIf="reviewTab === 'compare'"></div>
    <div class="menu-icon" 
         [class.active]="drawMode === 'line'"
         (click)="toggleDrawMode('line')">
      <!--<svg viewBox="0 0 24 24">
        <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
      </svg>-->
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 20 L20 4" stroke="#e3e3e3" stroke-width="2" fill="none"/>
      </svg>

    </div>
    <div class="menu-icon" 
         [class.active]="drawMode === 'circle'"
         (click)="toggleDrawMode('circle')">
      <!--<svg viewBox="0 0 24 24">
        <path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"/>
      </svg> -->
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="6" fill="none" stroke="#e3e3e3" stroke-width="2" />
    </svg>

    </div>

  </div>

  <!-- Main Content Area -->
  <div class="main-content">
    <div class="review-tabs" *ngIf="canUseCompareView" role="tablist" aria-label="Session view">
      <button
        type="button"
        class="review-tab"
        role="tab"
        [class.active]="reviewTab === 'this'"
        [attr.aria-selected]="reviewTab === 'this'"
        (click)="setReviewTab('this')">
        This Swing
      </button>
      <button
        type="button"
        class="review-tab"
        role="tab"
        [class.active]="reviewTab === 'compare'"
        [attr.aria-selected]="reviewTab === 'compare'"
        (click)="setReviewTab('compare')">
        Compare Swings
      </button>
    </div>

    <app-compare-swings
      *ngIf="canUseCompareView"
      [hidden]="reviewTab !== 'compare'"
      [username]="session?.username || ''"
      [currentSessionId]="sessionId"
      [currentSessionLabel]="session?.label || ''"
      [anchorSwing]="selectedSwing?.swing || null">
    </app-compare-swings>

    <div class="this-swing-review" [hidden]="reviewTab !== 'this'">
    <div class="camera-toggle" role="tablist" aria-label="Review camera">
      <button
        type="button"
        class="camera-toggle-btn"
        role="tab"
        [class.active]="activeReviewCamera === 'faceon'"
        [attr.aria-selected]="activeReviewCamera === 'faceon'"
        (click)="setReviewCamera('faceon')">
        Face-On
      </button>
      <button
        type="button"
        class="camera-toggle-btn"
        role="tab"
        [class.active]="activeReviewCamera === 'dtl'"
        [attr.aria-selected]="activeReviewCamera === 'dtl'"
        (click)="setReviewCamera('dtl')">
        Down the Line
      </button>
    </div>

    <div class="video-viewport">
    <div class="video-container" [class.show-dtl]="activeReviewCamera === 'dtl'">
      <div class="video-wrapper">
        <div class="video-content">
          <div class="missing-video" *ngIf="!hasFaceOnClip">
            No Face-On video for this swing
          </div>
          <div class="video-loading" *ngIf="hasFaceOnClip && isFaceOnLoading">
            <img src="assets/noun-loader-3784345-FFFFFF.png" class="video-spinner" alt="" />
            <span>Downloading video...</span>
          </div>
          <video #reviewFaceOnVideo
                 *ngIf="hasFaceOnClip"
                 preload="auto"
                 playsinline
                 muted
                 webkit-playsinline
                 [src]="faceOnVideoUrl"
                 (loadedmetadata)="onVideoMetadata()"
                 (durationchange)="onVideoMetadata()"
                 (progress)="onVideoMetadata()"
                 (canplay)="onVideoCanPlay('faceon')"
                 (loadeddata)="onVideoCanPlay('faceon')"
                 (error)="onVideoLoadError('faceon')"
                 (timeupdate)="onTimeUpdate($event)"
                 (ended)="onPlaybackEnded()">
            Your browser does not support the video tag.
          </video>

          <div
            class="draw-hitbox"
            *ngIf="mode !== null && hasFaceOnClip"
            (pointerdown)="onMouseDown($event, 'faceon')"
            (pointermove)="onMouseMove($event, 'faceon')"
            (pointerup)="onMouseUp($event, 'faceon')"
            (pointerleave)="onMouseUp($event, 'faceon')"
            (pointercancel)="onMouseUp($event, 'faceon')">
          </div>
           <svg #faceOnSVG class="overlay"
                       [class.drawing-enabled]="mode !== null"
                       (pointerdown)="onMouseDown($event, 'faceon')"
                       (pointermove)="onMouseMove($event, 'faceon')"
                       (pointerup)="onMouseUp($event, 'faceon')"
                       (pointerleave)="onMouseUp($event, 'faceon')"
                       (pointercancel)="onMouseUp($event, 'faceon')">
            <ng-container *ngFor="let shape of faceOnShapes">
              <circle *ngIf="shape.type === 'circle'"
                      [attr.cx]="shape.cx" [attr.cy]="shape.cy"
                      [attr.r]="shape.r"
                      [attr.stroke]="shape.selected ? '#fbbf24' : 'white'"
                      stroke-width="4" fill="transparent"
                      (pointerdown)="onShapeMouseDown($event, shape, 'faceon')"
                      (click)="selectShape($event, shape, 'faceon')"
                      class="hoverable"/>

              <line *ngIf="shape.type === 'line'"
                    [attr.x1]="shape.x1" [attr.y1]="shape.y1"
                    [attr.x2]="shape.x2" [attr.y2]="shape.y2"
                    [attr.stroke]="shape.selected ? '#fbbf24' : 'white'"
                    stroke-width="4"
                    (pointerdown)="onShapeMouseDown($event, shape, 'faceon')"
                    (click)="selectShape($event, shape, 'faceon')"
                      class="hoverable"/>
            </ng-container>
          </svg>
          <div class="clear-shapes-hotspot" *ngIf="faceOnShapes.length > 0">
            <button
              type="button"
              class="clear-shapes-btn"
              (pointerdown)="$event.stopPropagation()"
              (click)="clearAllShapes($event, 'faceon')">
              Remove all shapes
            </button>
          </div>
        </div>
      </div>

      <div class="video-wrapper">
        <div class="video-content">
          <div class="missing-video" *ngIf="!hasDtlClip">
            No Down the Line video for this swing
          </div>
          <div class="video-loading" *ngIf="hasDtlClip && isDtlLoading">
            <img src="assets/noun-loader-3784345-FFFFFF.png" class="video-spinner" alt="" />
            <span>Downloading video...</span>
          </div>
          <video #reviewDownTheLineVideo
                 *ngIf="hasDtlClip"
                 preload="auto"
                 playsinline
                 muted
                 webkit-playsinline
                 [src]="dtlVideoUrl"
                 (loadedmetadata)="onVideoMetadata()"
                 (durationchange)="onVideoMetadata()"
                 (progress)="onVideoMetadata()"
                 (canplay)="onVideoCanPlay('dtl')"
                 (loadeddata)="onVideoCanPlay('dtl')"
                 (error)="onVideoLoadError('dtl')"
                 (timeupdate)="onTimeUpdate($event)"
                 (ended)="onPlaybackEnded()">
            Your browser does not support the video tag.
          </video>
          <div
            class="draw-hitbox"
            *ngIf="mode !== null && hasDtlClip"
            (pointerdown)="onMouseDown($event, 'dtl')"
            (pointermove)="onMouseMove($event, 'dtl')"
            (pointerup)="onMouseUp($event, 'dtl')"
            (pointerleave)="onMouseUp($event, 'dtl')"
            (pointercancel)="onMouseUp($event, 'dtl')">
          </div>
          <svg #dtlSVG class="overlay"
                       [class.drawing-enabled]="mode !== null"
                       (pointerdown)="onMouseDown($event, 'dtl')"
                       (pointermove)="onMouseMove($event, 'dtl')"
                       (pointerup)="onMouseUp($event, 'dtl')"
                       (pointerleave)="onMouseUp($event, 'dtl')"
                       (pointercancel)="onMouseUp($event, 'dtl')">
            <ng-container *ngFor="let shape of downTheLineShapes">
              <circle *ngIf="shape.type === 'circle'"
                      [attr.cx]="shape.cx" [attr.cy]="shape.cy"
                      [attr.r]="shape.r"
                      [attr.stroke]="shape.selected ? '#fbbf24' : 'white'"
                      stroke-width="2" fill="transparent"
                      (pointerdown)="onShapeMouseDown($event, shape, 'dtl')"
                      (click)="selectShape($event, shape, 'dtl')"
                      class="hoverable"/>

              <line *ngIf="shape.type === 'line'"
                    [attr.x1]="shape.x1" [attr.y1]="shape.y1"
                    [attr.x2]="shape.x2" [attr.y2]="shape.y2"
                    [attr.stroke]="shape.selected ? '#fbbf24' : 'white'"
                    stroke-width="4"
                    (pointerdown)="onShapeMouseDown($event, shape, 'dtl')"
                    (click)="selectShape($event, shape, 'dtl')"
                    class="hoverable"/>
            </ng-container>
          </svg>
          <div class="clear-shapes-hotspot" *ngIf="downTheLineShapes.length > 0">
            <button
              type="button"
              class="clear-shapes-btn"
              (pointerdown)="$event.stopPropagation()"
              (click)="clearAllShapes($event, 'dtl')">
              Remove all shapes
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>

    <div class="start-mark-row">
      <button
        type="button"
        class="start-mark-btn"
        [disabled]="(!hasFaceOnClip && !hasDtlClip) || isBufferingVideos || isFaceOnLoading || isDtlLoading || savingStart"
        (click)="markStart()">
        {{ savingStart ? 'Saving start...' : 'Mark start' }}
      </button>
      <span class="start-mark-meta" *ngIf="hasSavedReviewStart()">
        Saved {{ formatTime(savedReviewStartTime()) }} for Face-On and Down the Line
      </span>
      <span class="start-mark-meta" *ngIf="!hasSavedReviewStart()">No start saved</span>
    </div>

    <div class="playback-bar">
      <div class="scrubber">
        <input
          type="range"
          class="scrubber-slider"
          min="0"
          [max]="duration || 0"
          [step]="sliderStep"
          [ngModel]="currentTime"
          (ngModelChange)="onScrub($event)"
          (pointerdown)="onScrubStart()"
          [disabled]="duration <= 0 || isBufferingVideos || isFaceOnLoading || isDtlLoading"
          [style.--scrub-percent]="scrubPercent"
          aria-label="Swing playback position"
        />
        <div class="scrubber-times">
          <span>{{ formatTime(currentTime) }}</span>
          <span *ngIf="isBufferingVideos || isFaceOnLoading || isDtlLoading">Downloading video...</span>
          <span>{{ formatTime(duration) }}</span>
        </div>
      </div>

      <div class="control-bar">
        <button 
          class="video-btn" 
          (click)="resetVideo()">
          <div class=""><img src="../../../assets/noun-previous-1000026-FFFFFF.png" style="height: 35px;"></div>
        </button>

        <button 
          class="video-btn" 
          *ngIf="!isPlaying"
          (click)="playVideo()">
          <div class=""><img src="../../../assets/noun-play-1000022-FFFFFF.png" style="height: 35px;"></div>
        </button>

        <button 
          class="video-btn" 
          *ngIf="isPlaying"
          (click)="pauseVideo()">
          <div class=""><img src="../../../assets/noun-pause-1000021-FFFFFF.png" style="height: 35px;"></div>
        </button>

        <div class="control-group">
            <label class="control-label">Playback Speed</label>
            <select 
              class="control-select" 
              [(ngModel)]="playbackSpeed">
              <option value="1">Full Speed</option>
              <option value="0.5">50%</option>
              <option value="0.25">25%</option>
              <option value="0.1">10%</option>
            </select>
        </div>

        <button
          type="button"
          class="download-package-btn"
          [class.preparing]="isDownloadingPackage"
          [disabled]="!selectedSwing || isDownloadingPackage || (!hasFaceOnClip && !hasDtlClip)"
          (click)="downloadSwingPackage()"
          [attr.aria-label]="isDownloadingPackage ? 'Preparing download' : 'Download swing package'"
          [title]="isDownloadingPackage ? 'Preparing download...' : 'Download videos and notes as a zip'">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
          </svg>
        </button>
      </div>
    </div>
    </div>
  </div>

  <!-- Right Sidebar with Accordions -->
  <div class="right-sidebar">
    <!-- Swings Accordion -->
    <div class="accordion">
      <button class="accordion-header" 
              [class.active]="isAccordionOpen('swings')"
              (click)="toggleAccordion('swings')">
        <span>Swings</span>
        <svg class="accordion-icon" viewBox="0 0 24 24">
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
        </svg>
      </button>
      <div class="accordion-content" [class.active]="isAccordionOpen('swings')">
        <div class="accordion-body">

          <!-- ✅ Add scrollable container around the table -->
          <div class="table-scroll-container">
            <table id="swinglist" class="table-select">
              <tr *ngIf="canCaptureSwing">
                <td class="button">
                  <button class="btn" (click)="showSwingCapture = true;">Record New Swing</button>
                </td>
              </tr>
              <tr *ngFor="let s of swings" [ngClass]="{ 'selected-accent': s.isSelected }">
                <td (click)="selectSwing(s)">
                  Swing #{{ s.swing.sequence }}
                  <span class="swing-result-label" *ngIf="swingResultLabel(s.swing.result)">
                    {{ swingResultLabel(s.swing.result) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>

        </div>
      </div>
    </div>



    <!-- Result Accordion -->
    <div class="accordion">
      <button class="accordion-header"
              [class.active]="isAccordionOpen('result')"
              (click)="toggleAccordion('result')">
        <span>Result</span>
        <svg class="accordion-icon" viewBox="0 0 24 24">
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
        </svg>
      </button>
      <div class="accordion-content" [class.active]="isAccordionOpen('result')">
        <div class="accordion-body">
          <div class="result-options">
            <button
              type="button"
              class="result-btn"
              [class.active]="selectedResult === 'DBL_THUMB_DWN'"
              (click)="setSwingResult('DBL_THUMB_DWN')"
              aria-label="Double thumbs down">👎👎</button>
            <button
              type="button"
              class="result-btn"
              [class.active]="selectedResult === 'THUMB_DWN'"
              (click)="setSwingResult('THUMB_DWN')"
              aria-label="Thumbs down">👎</button>
            <button
              type="button"
              class="result-btn"
              [class.active]="selectedResult === 'THUMB_UP'"
              (click)="setSwingResult('THUMB_UP')"
              aria-label="Thumbs up">👍</button>
            <button
              type="button"
              class="result-btn"
              [class.active]="selectedResult === 'DBL_THUMB_UP'"
              (click)="setSwingResult('DBL_THUMB_UP')"
              aria-label="Double thumbs up">👍👍</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Notes Accordion -->
    <div class="accordion">
      <button class="accordion-header" 
              [class.active]="isAccordionOpen('notes')"
              (click)="toggleAccordion('notes')">
        <span>Notes</span>
        <svg class="accordion-icon" viewBox="0 0 24 24">
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
        </svg>
      </button>
      <div class="accordion-content" [class.active]="isAccordionOpen('notes')">
        <div class="accordion-body">
          <app-autosave-textarea
            [text]="notes"
            [autoSaveDelayMilliseconds]="700"
            watermark="Swing note..."
            (autosave)="onNotesAutosave($event)"
          ></app-autosave-textarea>

        </div>
      </div>
    </div>

    <!-- Tags Accordion -->
    <div class="accordion">
      <button class="accordion-header" 
              [class.active]="isAccordionOpen('tags')"
              (click)="toggleAccordion('tags')">
        <span>Tags</span>
        <svg class="accordion-icon" viewBox="0 0 24 24">
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
        </svg>
      </button>
      <div class="accordion-content" [class.active]="isAccordionOpen('tags')">
        <div class="accordion-body">
          <div class="tags-container">
            <div class="tag" *ngFor="let tag of tags">
              {{tag}}
              <span class="tag-remove" (click)="removeTag(tag)">×</span>
            </div>
          </div>
          <input 
            type="text" 
            class="tag-input" 
            placeholder="Add a tag and press Enter..."
            [(ngModel)]="newTag"
            (keypress)="addTag($event)"
          >
        </div>
      </div>
    </div>
  
  <!-- Shot Data Accordion -->
    <div class="accordion">
      <button class="accordion-header" 
              [class.active]="isAccordionOpen('shotdata')"
              (click)="toggleAccordion('shotdata')">
        <span>Shot Data</span>
        <svg class="accordion-icon" viewBox="0 0 24 24">
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
        </svg>
      </button>
      <div class="accordion-content" [class.active]="isAccordionOpen('shotdata')">
        <div class="accordion-body">
          <div class="shot-form">
            <form>
              <div class="field" *ngFor="let item of shotData | keyvalue">
                <label>{{ item.value.label }}</label>
                <input
                  [(ngModel)]="item.value.value"
                  name="{{ item.key }}"
                  type="text"
                />
              </div>
              
              <div class="field"><label></label><button class="btn" (click)="saveShotData()">Save</button></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
